<template>
  <Modal
    :title="$t('edit_warehouse')"
    modalId="edit-modal"
    @submit="updateWarehouse"
  >
    <form @submit.prevent="updateWarehouse">
      <!-- Warehouse Name -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_name') }} <span class="text-danger">*</span>
        </label>
        <input type="text" v-model="warehouse.name" class="form-control" />
        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
      </div>

      <!-- Address -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_address') }}
        </label>
        <input type="text" v-model="warehouse.address" class="form-control" />
        <small v-if="errors.address" class="text-danger">{{ errors.address }}</small>
      </div>

      <!-- Phone -->
      <div class="mb-3">
        <label class="form-label fw-semibold">
          {{ $t('warehouse_phone_number') }}
        </label>
        <input type="text" v-model="warehouse.phone_number" class="form-control" />
        <small v-if="errors.phone_number" class="text-danger">
          {{ errors.phone_number }}
        </small>
      </div>

      <!-- General Error -->
      <div v-if="errorMessage" class="alert alert-danger py-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedWarehouse: {
      type: Object,
      default: () => ({}),
    },
    warehouses: Array,
  },

  data() {
    return {
      warehouse: {
        id: null,
        name: '',
        address: '',
        phone_number: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  watch: {
    selectedWarehouse: {
      immediate: true,
      handler(newWarehouse) {
        if (newWarehouse && newWarehouse.id) {
          this.warehouse = {
            ...newWarehouse,
          };
        }
      },
    },
  },

  methods: {
    async updateWarehouse() {
      this.errors = {};  // Reset errors
      this.errorMessage = "";  // Reset general error message

      // Frontend validation
      if (!this.warehouse.name.trim()) this.errors.name = "Warehouse name is required.";

      // Address is optional, trim it only if it's a string and not null/undefined
      if (this.warehouse.address && typeof this.warehouse.address === 'string') {
        this.warehouse.address = this.warehouse.address.trim();
      } else {
        this.warehouse.address = '';
      }

      // Phone number is optional but should be valid if entered
      if (this.warehouse.phone_number && this.warehouse.phone_number.trim()) {
        const phoneRegex = /^[0-9]{10,15}$/;
        if (!phoneRegex.test(this.warehouse.phone_number.trim())) {
          this.errors.phone_number = "Enter a valid phone number (10-15 digits).";
        }
      } else {
        this.warehouse.phone_number = '';
      }

      if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

      try {
        const response = await this.$axios.patch(
            apiUrls.inventory_warehouse.update.replace(':pk', this.warehouse.id),
            {
              name: this.warehouse.name.trim(),
              address: this.warehouse.address.trim() || null,
              phone_number: this.warehouse.phone_number.trim() || null,
            }
        );

        this.toast.success('Warehouse successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
         if (error.response?.data?.errors) {
          this.errors = { ...error.response.data.errors };
        } else if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        } else {
          this.errorMessage = "An unexpected error occurred. Please try again.";
        }
      }
    },
    resetForm() {
      this.warehouse = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>
